import React from 'react';

import { Text } from '@change/ds-core-ui';

import { useHeadline } from './hooks/useHeadline';

export const Headline: React.FC = () => {
	const {
		data: { translatedHeadline },
	} = useHeadline();
	return (
		<Text as="h1" variant="heading" className="m-0" data-qa="promote-heading" data-testid="promote-heading">
			{translatedHeadline}
		</Text>
	);
};
